import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import ThemeContext from '../../../../providers/ThemeProvider';

export const DiscountCoupon = ({ discountCode = 'GETWOW10', onClose }) => {
  const theme = useContext(ThemeContext);
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    localStorage.removeItem('src');
    setTimeout(() => {
      onClose();
    }, 400);
  };

  // Auto-close after 10 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 20_000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div className={`discount-coupon ${isClosing ? 'closing' : ''}`}>
        <button
          aria-label="Close"
          className="close-button"
          onClick={handleClose}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <div className="discount-coupon__content">
          <p className="discount-coupon__text">
            Welcome to Wowcher! Use code{' '}
            <span className="discount-code">{discountCode}</span> at checkout.
          </p>
        </div>
      </div>
      <style jsx>{`
        .discount-coupon {
          background-color: ${theme.colors.headerprimary};
          color: white;
          padding: 12px 20px;
          border-radius: 8px;
          position: fixed;
          height: auto;
          width: 280px;
          z-index: 10000;
          right: 20px;
          top: 20px;
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15),
            0 2px 4px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease-in-out;
          opacity: 0.9;
        }
        .discount-coupon.closing {
          transform: translateX(calc(100% + 40px));
        }
        .discount-coupon__content {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          padding-right: 20px;
        }
        .discount-coupon__text {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          text-align: center;
          color: white;
        }
        .discount-code {
          color: black;
          font-weight: bold;
          padding: 2px 6px;
          background: white;
          border-radius: 4px;
        }
        .close-button {
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          padding: 4px;
          font-size: 16px;
          position: absolute;
          top: 8px;
          right: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: opacity 0.2s;
        }
        .close-button:hover {
          opacity: 0.8;
        }
        @media only screen and (max-width: ${theme.breakpoints.mdUp}) {
          .discount-coupon {
            width: 230px;
          }
          .discount-coupon__text {
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
};

DiscountCoupon.propTypes = {
  discountCode: PropTypes.string,
  onClose: PropTypes.func,
};
